import { CTA, styled } from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { getLang, getTranslations } from '../translations';
import { useFeatureServices } from '../use-feature-services';
import { createConfiguration, createConstantData, createPartner, createProcess } from '../utils/get-tracking-event-data';
import { getSingleSelectedDealer } from '../utils/get-single-selected-dealer';
import { useVehicleStore } from '../store/vehicles';
import { InteractionLayerSizeV2 } from '@volkswagen-onehub/layer-manager';
import { FAQ } from '../FAQ';
import { getStep } from '../utils/get-step';
import { LayerContext, useInteractionLayer } from '../Layers';
import { useDealersStore } from '../utils/use-dealers-store';
import { VehicleData } from '../types';

const VolksKlickPageHeaderContainer = styled.div`
  display: flex;
  column-gap: ${props => props.theme.size.dynamic0020};
  align-items: baseline;
  svg {
    align-self: flex-end;
  }
`;

export const VolksKlickPageHeader = () => {
  const { volksklick } = getTranslations();
  const { tracking } = useFeatureServices();
  const lang = getLang();
  const route = useLocation();
  const vehicle = useVehicleStore().vehicle;
  const dealer = useDealersStore().getDealer(vehicle?.dealer_id as string);

  const partner = dealer || getSingleSelectedDealer();
  const step = getStep(route.pathname);
  const { closeLayer } = useContext(LayerContext);

  const openFAQLayer = useInteractionLayer(
    'volksklick-faq-layer',
    {
      size: InteractionLayerSizeV2.E,
      onClose: () => closeLayer('volksklick-faq-layer')
    }
  );

  const handleClick = () => {
    openFAQLayer((close) => (
      <FAQ close={close} />
    ));

    tracking.track('VWBasic_Button_Click', {
      ...createConstantData(),
      configuration: vehicle ? createConfiguration('VWBasic_Button_Click', vehicle as VehicleData, lang) : createConfiguration(),
      partner: createPartner(partner),
      process: createProcess(step),
      link: {
        url: window.location.href,
        name: volksklick.faqs.cta
      }
    });
  };

  return (
    <VolksKlickPageHeaderContainer>
      <CTA tag="button" emphasis="tertiary" onClick={handleClick}>
          {volksklick.faqs.cta}
      </CTA>
    </VolksKlickPageHeaderContainer>
  );
};
